import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import AsyncComputed from 'vue-async-computed';
import "./registerServiceWorker";
import dayjs from "dayjs"

import "normalize.css/normalize.css"; // A modern alternative to CSS resets

import ElementUI from "element-ui";
import "@/assets/index.css";
import locale from "element-ui/lib/locale/lang/zh-CN"; // lang i18n
import "@/styles/index.scss"; // global css
import "@/icons"; // icon
import "@/permission"; // permission control
import OssClient from "./components/oss-client/";
import "@/assets/style/base.scss"; // global css
import _ from "lodash";
import echarts from "vue-echarts";

import VueQuillEditor from "vue-quill-editor";

// require styles
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

Vue.use(VueQuillEditor /* { default global options } */);
import TableDropdown from "@/components/TableDropdown"

Vue.use(ElementUI, { locale });
Vue.use(OssClient);
Vue.use(AsyncComputed);
Vue.prototype._ = _;
Vue.prototype.$dayjs = dayjs;
Vue.component("chart", echarts);
Vue.component("TableDropdown", TableDropdown);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
